import { BadgeProps } from "./Badge";

export const formatCount = (count?: number): BadgeProps["countDisplay"] =>
  count?.toString().padStart(2, "0") ?? "0";
